<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Access to financing for high-growth African companies</h2>
    <p>Asoko Deal Platform is an exciting new extension to the Asoko platform, built around one core objective: connecting you with the right institutions to satisfy your financing requirements.</p>
    <p>Qualifying companies can access Asoko's continuously expanding ecosystem of investors, banks, lenders and advisories through a <b>free</b> submission process.</p>
    <div class="action-wrap">
      <a @click="openSolutions" class="cta-button" :class="colorMode === 'light' ? 'medium-button' : ''">Learn More</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'source-company-conversion',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openSolutions() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Source Company Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Source Company Block',
      })
      this.$router.push('/about/deals')
    },
  },
}
</script>
